module.exports = __webpack_public_path__ + "static/media/catastros-8.01405c87.png";